import PropTypes from 'prop-types';
import { ReactComponent as CloseIcon } from 'assets/icons/svgs/icon-close.svg';
import styles from './CloseButton.module.scss';

export const CloseButton = (props) => {
  const { text, variant, extendClass = '', onClick } = props;
  const variantClass = variant ? styles[variant] : styles.primary;
  const classes = [styles.button, variantClass, extendClass].join(' ');

  return (
    <button className={classes} type="button" onClick={onClick} data-testid="close-button">
      <CloseIcon className={styles.icon} data-testid="close-icon" />
      <span className={styles.text}>{text}</span>
    </button>
  );
};

CloseButton.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.string,
  extendClass: PropTypes.string,
  onClick: PropTypes.func,
};
